module.exports = __webpack_public_path__ + "img/google-analytics.721e690d.jpg";